export const removeSpecialCharacters = (title: string) =>
  title.replace(/[-\d]/g, '');

export default removeSpecialCharacters;
